module.exports = (__parcel__import__("aOwhF")).then(() => parcelRequire('lmhgI'));